import { PlanTaxiResponse } from '../../../shared/types';
import React, { createContext, useContext, useState } from 'react';

type ContextType<S> = [S, React.Dispatch<React.SetStateAction<PlanTaxiResponse>>] | null;

const initialState = null;
const TripsTaxiInfoContext = createContext<ContextType<PlanTaxiResponse>>(null);
TripsTaxiInfoContext.displayName = 'TripsTaxiInfoContext';

function useCurrentTrip() {
    const context = useContext(TripsTaxiInfoContext);
    if (!context) {
        throw new Error(`useCurrentTrip must be used within a TripsTaxiInfoProvider`);
    }

    const [currentTrip, setCurrentTrip] = context;

    return {
        currentTrip,
        setCurrentTrip,
    };
}

function TripsTaxiInfoProvider(props) {
    const trip = useState(initialState);
    return <TripsTaxiInfoContext.Provider value={trip} {...props} />;
}

export { TripsTaxiInfoProvider, useCurrentTrip };
